import { noddiAsync } from 'noddi-async';
import { PERSONAL_INFO_REVIEW_MUTATION_KEY } from './types';

/**
 * True while one of this review's own requests is in flight.
 *
 * Scoped on purpose. An unscoped `useIsMutating()` disables Confirm and Remind
 * me later whenever anything anywhere in the customer app mutates, so unrelated
 * background work can leave the prompt looking broken. What it has to keep
 * closed is narrower: Confirm must not finish a step on top of a half-applied
 * add or remove from this flow.
 */
export const useReviewMutationsPending = (): boolean =>
  noddiAsync.getReactQuery().useIsMutating({ mutationKey: PERSONAL_INFO_REVIEW_MUTATION_KEY }) > 0;
